import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Form, Row, Col, Alert, Spinner, Modal } from 'react-bootstrap';
import { fetchGetData, fetchPostData, fetchFormData } from './api'; // Import your common API file

const TrackEmployee = () => {
    const [loading, setLoading] = useState(false);
    const [checkLoading, setCheckLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [percentage, setPercentage] = useState('');

    const [successMessage, setSuccessMessage] = useState('');
    const [companyName, setCompanyName] = useState(''); // 6765345d455383ea43aa2897
    const [jobRole, setJobRole] = useState(''); // 1725
    const [displayTitle, setDisplayTitle] = useState(''); // Accountant
    const [searchTitle, setSearchTitle] = useState('');
    const [noOfCandidates, setNoOfCandidates] = useState('');
    const [gender, setGender] = useState('NULL');
    const [maritalStatus, setMaritalStatus] = useState('NULL');
    const [salary, setSalary] = useState('12000');
    const [age, setAge] = useState('45');
    const [experience, setExperience] = useState('NULL');
    const [qualification, setQualification] = useState('10');
    const [kilometer, setKilometer] = useState('20');
    const [address, setAddress] = useState('');
    const [banner, setBanner] = useState('https://files.nithra.mobi/nithra-jobs/staffing/banner_whatsapp.png');
    const [description, setDescription] = useState('');
    const [district, setDistrict] = useState('');
    const [selectedArea, setSelectedArea] = useState('');
    const [districts, setDistricts] = useState([]);
    const [jobRoles, setJobRoles] = useState([]);
    const [jobEmployer, setEmployer] = useState([]);
    const [jobExecutive, setJobExecutive] = useState([]);
    const [executive, setExecutive] = useState('');
    const [areas, setAreas] = useState([]);
    const getCurrentDate = () => {
        const today = new Date();
        today.setDate(today.getDate() + 2); // Add 1 to the current date
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [minDate, setMinDate] = useState(getCurrentDate());
    const [startDate, setStartDate] = useState('');

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [relavantList, setRelavantList] = useState({
        title: [],
        course: []
    });

    // Fetch data on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [districtRes, jobEmployer, jobExecutive] = await Promise.all([ // jobRoleRes
                    fetchGetData('/master/get/district/city'), // Replace with actual API
                    // fetchGetData('/master/get/title'),    // Replace with actual API
                    fetchGetData('/master/get/employer/new'),    // Replace with actual API
                    fetchGetData('/master/get/executive')

                ]);
                setDistricts(districtRes.data);
                // setJobRoles(jobRoleRes.data);
                setEmployer(jobEmployer.data);
                setJobExecutive(jobExecutive.data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setErrorMessage('Error loading district and job role data.');
            }
        };

        fetchData();
    }, []);


    const handlePercentageChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, ""); // Remove non-numeric
        if (value !== "100" && value.length > 2) {
            value = value.slice(0, 2); // Allow up to 2 digits unless it's exactly "100"
        }
        setPercentage(value);
    };

    const handleDistrictChange = (e) => {
        const selectedDistrictId = e.target.value;
        setDistrict(selectedDistrictId);
        setAreas(''); // Reset selected area

        // Find the selected district from the districts array
        const selectedDistrict = districts.find(d => d.id === Number(selectedDistrictId));

        // If district is found, set its areas
        if (selectedDistrict) {
            setAreas(selectedDistrict.areas); // Set areas from the selected district
        } else {
            setAreas([]); // Reset areas if no district is selected
        }
    };

    const validateForm = () => {
        // if (typeof noOfCandidates === "string") {
        //     noOfCandidates = noOfCandidates.trim();
        // } else {
        //     console.log("Invalid data type:", noOfCandidates);
        // }
        if (!companyName.trim()) return "Employer is required.";
        // if (!jobRole) return "Job role must be selected.";
        if (!displayTitle) return "Display title is required.";
        if (!searchTitle) return "Job profile is required.";
        if (!noOfCandidates) return "Vacany count is required.";
        if (!gender) return "Gender must be selected.";
        if (!maritalStatus) return "marital status must be selected.";
        if (!experience) return "Experience is required.";
        if (!qualification) return "Qualification is required.";
        if (!address) return "Address must required.";
        if (!district) return "District must be selected.";
        if (!selectedArea) return "Area must be selected.";
        if (!kilometer) return "Kilometer is required.";
        if (!startDate) return "Interview date is required.";
        if (!banner) return "Image is required.";
        return null;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationError = validateForm();
        if (validationError) {
            setErrorMessage(validationError);
            return;
        }

        // Create a new FormData object and append all form fields to it
        const formData = new FormData();
        formData.append('companyName', companyName);
        formData.append('jobRole', jobRole);
        formData.append('displayTitle', displayTitle);
        formData.append('searchTitle', searchTitle);
        formData.append('noOfCandidates', noOfCandidates);
        formData.append('gender', gender);
        formData.append('salary', salary);
        formData.append('percentage', percentage);

        formData.append('maritalStatus', maritalStatus);
        formData.append('experience', experience);
        formData.append('qualification', qualification);
        formData.append('address', address);
        formData.append('district', district);
        formData.append('selectedArea', selectedArea);
        formData.append('kilometer', kilometer);
        formData.append('interviewDate', startDate);
        formData.append('banner', banner);
        formData.append('description', description);
        formData.append('executive', executive);
        const requestData = {
            companyName,
            jobRole,
            displayTitle,
            searchTitle,
            noOfCandidates,
            gender,
            salary,
            percentage,
            maritalStatus,
            experience,
            qualification,
            address,
            district,
            selectedArea,
            kilometer,
            interviewDate: startDate,
            banner,
            description,
            executive,
        };
        setLoading(true);

        try {
            // const response = await fetchPostData('/employer/vacancy', formData, {
            //     'Content-Type': 'application/json',
            // });
            const response = await fetchPostData('/employer/vacancy', JSON.stringify(requestData), {
                'Content-Type': 'application/json',
            });

            if (response.success) {
                setSuccessMessage('Form submitted and processed successfully!');
                // setCompanyName('');
                // setJobRole('');
                // setNoOfCandidates('');
                // setGender('');
                // setMaritalStatus('');
                // setSalary('');
                // setAge('');
                // setExperience('');
                // setQualification('');
                // setMobile('');
                // setAddress('');
                // setDistrict('');
                // setSelectedArea('');

                setCompanyName('');
                setJobRole('');
                setDisplayTitle('');
                setSearchTitle('');
                setNoOfCandidates('');
                setGender('NULL');
                setMaritalStatus('NULL');
                setSalary('');
                setPercentage('');
                setAge('');
                setExperience('NULL');
                setQualification('');
                setKilometer('50');
                setAddress('');
                setDistrict('');
                setSelectedArea('');
                setDistricts([]);
                setJobRoles([]);
                setEmployer([]);
                setExecutive('');
                setAreas([]);
                setStartDate('');
                setBanner('');
                setDescription('');
            } else {
                setErrorMessage('Form submission failed.');
            }
        } catch (error) {
            console.error('Error submitting the form:', error);
            // setErrorMessage('An error occurred while submitting the form.');
            setErrorMessage(JSON.stringify(error.message));
        } finally {
            setLoading(false);
        }

        setTimeout(() => {
            setErrorMessage(''); // Clear error message
            setSuccessMessage(''); // Clear success message
        }, 5000);
    };



    const handleSelectEmployerChange = (e) => {
        const selectedEmployerId = e.target.value;
        setCompanyName(selectedEmployerId)
        if (selectedEmployerId || true) {
            fetchData(selectedEmployerId); // Fetch data based on selected employer
        } else {
            // setVacancy([]);
        }
    };
    const fetchData = async (selectedEmployerId) => {
        // setCompanyName('');
        setJobRole('');
        setDisplayTitle('');
        setSearchTitle('');
        setNoOfCandidates('');
        setGender('NULL');
        setMaritalStatus('NULL');
        setSalary('');
        setPercentage('');
        setAge('');
        setExperience('NULL');
        setQualification('10');
        setKilometer('20');
        setAddress('');
        setDistrict('');
        setSelectedArea('');
        // setDistricts([]);
        // setJobRoles([]);
        // setEmployer([]);
        // setAreas([]);
        setStartDate('');
        if (selectedEmployerId) {
            try {
                const [jobVacancy] = await Promise.all([
                    fetchGetData('/employer/get/employer/vacancy', { id: selectedEmployerId, isVacancy: true })
                ]);
                // setVacancy(jobVacancy.data);
                if (jobVacancy.data) {
                    // setCompanyName('');
                    setJobRole(jobVacancy?.data?.jobRole || "");
                    setDisplayTitle(jobVacancy?.data?.displayTitle || "");
                    setSearchTitle(jobVacancy?.data?.searchTitle || "");
                    setNoOfCandidates(jobVacancy?.data?.noOfCandidates || "");

                    const match = jobEmployer.find(job => job._id === selectedEmployerId);
                    if (match) {
                        setExecutive(match.executive); // or whatever you want to set here
                    }
                    // const gender = jobVacancy?.data?.gender || "NULL";
                    // setGender((typeof gender === "string") ? gender.toString().toUpperCase() : gender.toString());
                    // const maritalStatus = jobVacancy?.data?.maritalStatus || "NULL";
                    // setMaritalStatus((typeof maritalStatus === "string") ? maritalStatus.toString().toUpperCase() : maritalStatus.toString());
                    // setSalary(jobVacancy?.data?.salary || "");
                    // setAge('');
                    // const experience = jobVacancy?.data?.experience || "NULL";
                    // setExperience((typeof experience === "string") ? experience.toString().toUpperCase() : experience.toString());

                    // Helper function to check valid values
                    const getValidValue = (value, defaultValue = "NULL") => {
                        return value !== null && value !== undefined ? value : defaultValue;
                    };

                    const gender = getValidValue(jobVacancy?.data?.gender);
                    setGender(gender.toString().toUpperCase());

                    const maritalStatus = getValidValue(jobVacancy?.data?.maritalStatus);
                    setMaritalStatus(maritalStatus.toString().toUpperCase());

                    setSalary(getValidValue(jobVacancy?.data?.salary, "")); // Default empty string for salary
                    setAge(''); // Explicitly setting age to empty string

                    const experience = getValidValue(jobVacancy?.data?.experience);
                    setExperience(experience.toString().toUpperCase());

                    setQualification(jobVacancy?.data?.qualification || "");
                    setKilometer(jobVacancy?.data?.kilometer || "");
                    setAddress(jobVacancy?.data?.address || "");
                    setDistrict(jobVacancy?.data?.district || "");
                    const selectedDistrictId = jobVacancy?.data?.district || ""
                    const selectedDistrict = districts.find(d => d.id === Number(selectedDistrictId));

                    // If district is found, set its areas
                    if (selectedDistrict) {
                        setAreas(selectedDistrict.areas); // Set areas from the selected district
                    } else {
                        setAreas([]); // Reset areas if no district is selected
                    }
                    setSelectedArea(jobVacancy?.data?.selectedArea || jobVacancy?.data?.city || "");
                    // setDistricts([]);
                    // setJobRoles([]);
                    // setEmployer([]);
                    // setAreas([]);
                    setStartDate('');
                    setBanner(getValidValue(jobVacancy?.data?.banner, "https://files.nithra.mobi/nithra-jobs/staffing/banner_whatsapp.png"));
                    setDescription(getValidValue(jobVacancy?.data?.description, ""));
                } else {
                    // setCompanyName('');
                    setJobRole('');
                    setDisplayTitle('');
                    setSearchTitle('');
                    setNoOfCandidates('');
                    setGender('NULL');
                    setMaritalStatus('NULL');
                    setSalary('');
                    setPercentage('');
                    setAge('');
                    setExperience('NULL');
                    setQualification('10');
                    setKilometer('20');
                    setAddress('');
                    setDistrict('');
                    setSelectedArea('');
                    // setDistricts([]);
                    // setJobRoles([]);
                    // setEmployer([]);
                    // setAreas([]);
                    setStartDate('');
                    setBanner('');
                    setDescription('');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };
    const checkRelavant = async () => {
        setCheckLoading(true);
        const setrelavantPromt = displayTitle + ", " + searchTitle;
        const [relavant] = await Promise.all([
            fetchGetData('/employer/get/related', { q: searchTitle })
        ]);
        // console.log(relavant)
        setRelavantList(relavant);
        setCheckLoading(false);
        handleShow()
    };
    return (
        <div className="container mt-5">
            <Card className="p-4 shadow-sm">
                <h4 className="mb-4">Create employer vacancy</h4>
                {loading && (
                    <div className="text-center my-4">
                        <Spinner animation="border" />
                    </div>
                )}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="companyName">
                                <Form.Label>Choose employer</Form.Label>
                                <Form.Select
                                    value={companyName}
                                    // onChange={(e) => setCompanyName(e.target.value)}
                                    onChange={handleSelectEmployerChange}
                                    required
                                >
                                    <option value="">Choose employer</option>
                                    {jobEmployer.map(role => (
                                        <option key={role.id} value={role.id}>
                                            {role.english}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {/*<Col md={6}>*/}
                        {/*    <Form.Group controlId="jobRole">*/}
                        {/*        <Form.Label>Job Role</Form.Label>*/}
                        {/*        <Form.Select*/}
                        {/*            value={jobRole}*/}
                        {/*            onChange={(e) => setJobRole(e.target.value)}*/}
                        {/*            required*/}
                        {/*        >*/}
                        {/*            <option value="">Select Job Role</option>*/}
                        {/*            {jobRoles.map(role => (*/}
                        {/*                <option key={role.id} value={role.id}>*/}
                        {/*                    {role.english}*/}
                        {/*                </option>*/}
                        {/*            ))}*/}
                        {/*        </Form.Select>*/}
                        {/*    </Form.Group>*/}
                        {/*</Col>*/}
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Display title</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={displayTitle}
                                    onChange={(e) => setDisplayTitle(e.target.value)}
                                    maxLength="80"
                                    title="Enter display title"
                                    required
                                    placeholder="Enter display title"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="mobile">
                                <Form.Label>Job profile</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3} // Number of rows for the textarea
                                    value={searchTitle}
                                    onChange={(e) => setSearchTitle(e.target.value)}
                                    required
                                    placeholder="Enter job profile"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="noOfCandidates">
                                <Form.Label>No of candidates</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={noOfCandidates}
                                    onChange={(e) => setNoOfCandidates(e.target.value)}
                                    minLength={1}
                                    maxLength={3}
                                    required
                                    placeholder="Enter no of candidates"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="gender">
                                <Form.Label>Gender</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="male"
                                        name="gender"
                                        label="Male"
                                        value="0"
                                        checked={gender === '0'}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="female"
                                        name="gender"
                                        label="Female"
                                        value="1"
                                        checked={gender === '1'}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="other"
                                        name="gender"
                                        label="None"
                                        value="NULL"
                                        checked={gender === 'NULL'}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="maritalStatus">
                                <Form.Label>Marital status</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="Unmarried"
                                        name="maritalStatus"
                                        label="Unmarried"
                                        value="0"
                                        checked={maritalStatus === '0'}
                                        onChange={(e) => setMaritalStatus(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="Married"
                                        name="maritalStatus"
                                        label="Married"
                                        value="1"
                                        checked={maritalStatus === '1'}
                                        onChange={(e) => setMaritalStatus(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="ed allowed"
                                        name="maritalStatus"
                                        label="Both Married and Unmarried allowed"
                                        value="NULL"
                                        checked={maritalStatus === 'NULL'}
                                        onChange={(e) => setMaritalStatus(e.target.value)}
                                        required
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Salary</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={salary}
                                    onChange={(e) => setSalary(e.target.value)}
                                    // pattern="^[6789][0-9]{9}$"
                                    pattern="^(10000|[1-8][0-9]{4}|9[0-8][0-9]{3}|99000)$"
                                    title="Salary must be between 10000 and 99000"
                                    min="10000"
                                    required
                                    placeholder="Enter salary"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group controlId="percentage">
                                <Form.Label>Percentage(%) <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    value={percentage}
                                    onChange={handlePercentageChange}
                                    min="0"
                                    max="100"
                                    required
                                    placeholder="Enter percentage"
                                />
                            </Form.Group>
                        </Col>



                        <Col md={6}>
                            <Form.Group controlId="age">
                                <Form.Label>Age (Optional)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={age}
                                    onChange={(e) => setAge(e.target.value)}
                                    pattern="^(1[89]|[2-7][0-9]|80)$"
                                    title="Age must be between 18 and 80"
                                    placeholder="Enter age"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="experience">
                                <Form.Label>Experience</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="Fresher"
                                        name="experience"
                                        label="Fresher"
                                        value="0"
                                        checked={experience === '0'}
                                        onChange={(e) => setExperience(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="Experienced"
                                        name="experience"
                                        label="Experienced"
                                        value="1"
                                        checked={experience === '1'}
                                        onChange={(e) => setExperience(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="BothFresherAndExperienced"
                                        name="experience"
                                        label="Both Fresher and Experienced allowed"
                                        value="NULL"
                                        checked={experience === 'NULL'}
                                        onChange={(e) => setExperience(e.target.value)}
                                        required
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="qualification">
                                <Form.Label>Qualification (Optional)</Form.Label>
                                <Form.Select
                                    value={qualification}
                                    onChange={(e) => setQualification(e.target.value)}
                                >
                                    <option value="">Select Qualification</option>
                                    <option value="5">DIPLOMA</option>
                                    <option value="6">UG</option>
                                    <option value="7">PG</option>
                                    <option value="10">OTHERS</option>
                                    <option value="11">ITI</option>
                                    <option value="12">DOCTORATE</option>
                                    <option value="13">SCHOOL</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="mobile">
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3} // Number of rows for the textarea
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    required
                                    placeholder="Enter company/job address"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="district">
                                <Form.Label>District</Form.Label>
                                <Form.Select
                                    value={district}
                                    onChange={handleDistrictChange}
                                    required
                                >
                                    <option value="">Select District</option>
                                    {districts.map(district => (
                                        <option key={district.id} value={district.id}>
                                            {district.dist}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="area">
                                <Form.Label>Area</Form.Label>
                                <Form.Select
                                    value={selectedArea}
                                    onChange={(e) => setSelectedArea(e.target.value)}
                                    required
                                >
                                    <option value="">Select Area</option>
                                    {areas.map(area => (
                                        <option key={area.id} value={area.id}>
                                            {area.area_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="experience">
                                <Form.Label>Kilometer from selected area (Optional)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={kilometer}
                                    onChange={(e) => setKilometer(e.target.value)}
                                    pattern="^(10|[1-9][0-9]{1,2}|1000)$"
                                    title="kilometer must be between 10 and 1000"
                                    placeholder="Enter kilometer"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="startDate">
                                <Form.Label>Interview Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    min={minDate}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Banner image</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={banner}
                                    onChange={(e) => setBanner(e.target.value)}
                                    maxLength="80"
                                    title="Enter banner image"
                                    required
                                    placeholder="Enter banner image"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="mobile">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3} // Number of rows for the textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    required
                                    placeholder="Enter description"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="executiveName">
                                <Form.Label>Executive <small className="text-danger">*</small></Form.Label>
                                <Form.Select
                                    value={executive}
                                    onChange={(e) => setExecutive(e.target.value)}
                                    required
                                >
                                    <option value="">Choose executive</option>
                                    {jobExecutive.map(role => (
                                        <option key={role.id} value={role.id}>
                                            {role.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="text-center">
                        {searchTitle.length > 10 && displayTitle.length > 4 && (
                            <Button variant="warning" disabled={checkLoading} onClick={checkRelavant}>
                                {checkLoading ? 'Checking...' : 'Check'}
                            </Button>
                        )}
                        &nbsp;&nbsp;
                        <Button type="submit" variant="primary" disabled={loading} onClick={(e) => {
                            if (!window.confirm('Are you sure you want to submit?')) {
                                e.preventDefault(); // Prevent form submission if the user cancels
                            }
                        }}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </Button>
                    </div>
                </Form>
                {errorMessage && (
                    <Alert variant="danger" className="mt-3">
                        {errorMessage}
                    </Alert>
                )}
                {successMessage && (
                    <Alert variant="success" className="mt-3">
                        {successMessage}
                    </Alert>
                )}
            </Card>
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{searchTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {/* JOB TITLES */}
                        <div className="col-md-6">
                            <strong>JOB TITLES:</strong>
                            <ol>
                                {relavantList['title'].map((item, index) => (
                                    <li key={index}>{item.english}</li>
                                ))}
                            </ol>
                        </div>

                        {/* COURSES */}
                        <div className="col-md-6">
                            <strong>COURSES:</strong>
                            <ol>
                                {relavantList['course'].map((item, index) => (
                                    <li key={index}>{item.course}</li>
                                ))}
                            </ol>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default TrackEmployee;
